export default "__VITE_PUBLIC_ASSET__9a86ec34__"